module.exports = __webpack_public_path__ + "static/img/html.1ff6b18f.png";